import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

@Component({
    selector: 'icc-complaint-appointment-note',
    templateUrl: './complaint-appointment-note.component.html',
    styleUrls: ['./complaint-appointment-note.component.scss'],
})
export class ComplaintAppointmentNoteComponent {

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            note: string
        },
    ) {}

    close() {
        this.dialogRef.close();
    }
}
